/** A small accessible bar chart. Values are drawn as SVG bars; a visually hidden table carries the same numbers. */
import { html } from '../core/html.js';

/**
 * @param {string[]} labels  one per bar (ISO dates are shortened to "12 Oct")
 * @param {number[]} values
 * @param {{title: string, format?: (n:number)=>string, height?: number}} options
 */
export function barChart(labels, values, { title, format = String, height = 160 }) {
  const max = Math.max(1, ...values);
  const n = Math.max(1, values.length);
  const width = 600;
  const gap = n > 60 ? 0.5 : 2;
  const bw = (width - gap * (n - 1)) / n;
  const short = (label) => {
    const d = new Date(`${label}T00:00:00`);
    return Number.isNaN(d.getTime()) ? label : d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
  };
  const total = values.reduce((a, b) => a + b, 0);
  return html`<figure class="chart" style="margin:0"><figcaption class="b">${title} <span class="mu sm">Total ${format(total)}</span></figcaption>
    <svg viewBox="0 0 ${width} ${height}" width="100%" role="img" aria-label="${title}. Total ${format(total)}. Highest ${format(Math.max(0, ...values))}." preserveAspectRatio="none" style="display:block;max-height:${height}px">
      ${values.map((v, i) => {
        const h = v === 0 ? 1 : Math.max(2, (v / max) * (height - 4));
        return html`<rect x="${(i * (bw + gap)).toFixed(2)}" y="${(height - h).toFixed(2)}" width="${bw.toFixed(2)}" height="${h.toFixed(2)}" rx="1" fill="var(--pr)" opacity="${v === 0 ? 0.25 : 0.9}"><title>${short(labels[i])}: ${format(v)}</title></rect>`;
      })}
    </svg>
    <div class="row between xs mu"><span>${short(labels[0] || '')}</span><span>${short(labels[labels.length - 1] || '')}</span></div></figure>`;
}
